<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ca_code,ca_desc"
      placeholder="输入科目编号、名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearch">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/finance/category/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.ca_code}}</p>
          <p class="list-item-muted">{{item.ca_desc}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ca_class}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.ca_status=='已启用'}"
          >{{item.ca_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
    <add-button to="/finance/category_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/finance/category/list",
      filters: [
        {
          type: "condition",
          label: "类别",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部类别"
            },
            {
              value: 1,
              label: "资产",
              condition: "ca_class='资产'"
            },
            {
              value: 2,
              label: "负债",
              condition: "ca_class='负债'"
            },
            {
              value: 3,
              label: "权益",
              condition: "ca_class='所有者权益'"
            },
            {
              value: 4,
              label: "成本",
              condition: "ca_class='成本'"
            },
            {
              value: 5,
              label: "损益",
              condition: "ca_class='损益'"
            }
          ]
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部状态"
            },
            {
              value: 1,
              label: "已启用",
              condition: "ca_statuscode='AUDITED'"
            },
            {
              value: 2,
              label: "已禁用",
              condition: "ca_statuscode='DISABLED'"
            }
          ]
        }
      ]
    };
  }
};
</script>